document.addEventListener('DOMContentLoaded', function () {
  const tabLinks = document.querySelectorAll('.gm-tab-links .gm-target');
  const tabContents = document.querySelectorAll('.gm-tab-content');

  tabLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const tabIndex = this.parentElement.getAttribute('data-tab-index');

      // Hide all tab contents
      tabContents.forEach(content => content.style.display = 'none');
      // Show the selected tab content
      document.querySelector(`.gm-tab-content[data-tab-index="${tabIndex}"]`).style.display = 'block';
    });
  });
});